"use client";

import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { initializeSentry } from "@/lib/sentry-init";

/**
 * Client-side Sentry initialization component with error boundary.
 *
 * This component initializes Sentry error tracking on the client side and
 * wraps children with Sentry.ErrorBoundary to catch React component errors.
 *
 * Side effects:
 * - Initializes Sentry SDK on first mount
 * - Provides error boundary for React errors
 */
export function SentryProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initializeSentry();
  }, []);

  return (
    <Sentry.ErrorBoundary fallback={<div>Something went wrong. Please refresh the page.</div>}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
